export default __webpack_public_path__ + "static/media/Meesho.2c382134.jpg";